import { isProduction } from "@/helpers/global/env.func";

export const config = {
  company: 'fubon',
  market: 'hk',
  locale: 'hk',
  version: 'itrade7.5-v7.0.1',
  company_title: 'company_title',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  routerPrefix: isProduction() ? (window.config?.webPath && `/${window.config.webPath}` || '') : '',
  thirdPartyLink: '',
  checkTabs: true,
  apis: {
    winvestorApi: true,
    mdsApi: true,
  },
  layouts: {
    fullLayout: {
      logoImgName: 'logo_dark.svg',
    },
    mainLayout: {
      logoImgName: 'logo_light.svg',
    }
  },
  pages: {
    login: {
      ctrl: { securityTips: false },
      otp:true
    },
    trade:{
      rewrite: true,
      asset : true,
      instrument : true,
      placeorderoption : true,
      portfolio:true,
      bidask:true,
      ctrl:{ 
        marketFilter : true,
        orderFilter : true
      }
    },
    market:{
      rewrite:true,
      init:{ isOpenPieChart : true },
      ctrl:{ placeOrder : true }
    },
    placeorder:{
      ctrl :{ BuySellBtn : true }
    },
    fundManagement: {
      fundTransfer:{
        queryCurrencyConversion:true
      },
      fundTransferEnquiry:{
        foreignExchangeEnquiry:true
      }
    },
    accountdata:{
      rewrite:true
    },
    account:{
      ctrl:{ disablePlaceOrder : true }
    },
    ipo:{
      margin:{
        disableCancel:false
      },
      cancel:{
        useIpoAppliedDetailsEnquiryAPI:false
      }
    }
  },
  helpers:{
    functions:{
      accountToOption: false
    }
  },
  actions: {
    app:{
      place_order:true
    },
    trading: {
      getCashAccount: true,
      getWatchlist : true
    }
  },
  constants: {
    winVest: {
      winvestorDeviceID: 'itrade7.5-web-ttl',
      winvestorConsumerId: 'winvestor_ttl_broker',
      winvestorConsumerSecret: '$2y$10$i2c7LGyreYVUYjvQg1huUupnLufpzTugDyelyaowsZGe36j8N5KFi',
    },
    apiEnv: {
      itradeAPI: '',
      itradePath: '',
    
      MDSStreamingAPI: '',
      MDSSnapshotAPI: '',
      MDSOthersAPI: '',
      MDSPath: '',
      MDSEntityKey: '',
      MDSSuperkey: '',
    
      winvestorAPI: '',
      winvestorPath: 'ttl/api'
    }
  }
}